import type { SxProps, Theme } from "@mui/material";

/** Column-count options for the grid, matching the "4 / 6" toggle in the design. */
export const COLUMN_OPTIONS = [4, 6] as const;
export type ColumnCount = (typeof COLUMN_OPTIONS)[number];

// Responsive on small screens, honoring the column toggle from md up.
export const gridColumnsSx = (columns: ColumnCount): SxProps<Theme> => ({
  display: "grid",
  gridTemplateColumns: {
    xs: "repeat(2, 1fr)",
    sm: "repeat(3, 1fr)",
    md: `repeat(${columns}, 1fr)`,
  },
  gap: 4,
});

export const TILE_CARD_SX: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  borderRadius: 2,
  overflow: "hidden",
  border: 1,
  borderColor: "tokens.outlines.defaultBordersBalanced",
  bgcolor: theme.palette.background["paper-elevation-1"],
});

export const TILE_CAPTION_SX = {
  px: 3,
  py: 2,
  display: "flex",
  flexDirection: "column",
  gap: 1,
} as const;
